import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, type, folder }) =>
    present(
      repository
        .updateFolder(folder)
        .then((folder) => ({ namespace, type, folder }))
        .catch(() => Promise.reject({ namespace, type, folder })),
    );
}

export type { Interactor };

export { createInteractor };
